/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type APIResponseBase,
    APIResponseBaseFromJSON,
    APIResponseBaseToJSON,
} from '../models/APIResponseBase';
import {
    type GDPRConsentLevel,
    GDPRConsentLevelFromJSON,
    GDPRConsentLevelToJSON,
} from '../models/GDPRConsentLevel';
import {
    type GDPRConsentRequest,
    GDPRConsentRequestFromJSON,
    GDPRConsentRequestToJSON,
} from '../models/GDPRConsentRequest';
import {
    type GetConsentGdpr200Response,
    GetConsentGdpr200ResponseFromJSON,
    GetConsentGdpr200ResponseToJSON,
} from '../models/GetConsentGdpr200Response';
import {
    type PutConsentGdpr200Response,
    PutConsentGdpr200ResponseFromJSON,
    PutConsentGdpr200ResponseToJSON,
} from '../models/PutConsentGdpr200Response';

export interface DeleteConsentGdprRequest {
    slashIDSdkVersion?: string;
    consentLevels?: Array<GDPRConsentLevel>;
    deleteAll?: boolean;
}

export interface GetConsentGdprRequest {
    slashIDSdkVersion?: string;
}

export interface PostConsentGdprRequest {
    gDPRConsentRequest: GDPRConsentRequest;
    slashIDSdkVersion?: string;
}

export interface PutConsentGdprRequest {
    gDPRConsentRequest: GDPRConsentRequest;
    slashIDSdkVersion?: string;
}

/**
 * 
 */
export class PersonConsentsApi extends runtime.BaseAPI {

    /**
     * Creates request options for deleteConsentGdpr without sending the request
     */
    async deleteConsentGdprRequestOpts(requestParameters: DeleteConsentGdprRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['consentLevels'] != null) {
            queryParameters['consent_levels'] = requestParameters['consentLevels'];
        }

        if (requestParameters['deleteAll'] != null) {
            queryParameters['deleteAll'] = requestParameters['deleteAll'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['slashIDSdkVersion'] != null) {
            headerParameters['SlashID-SdkVersion'] = String(requestParameters['slashIDSdkVersion']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/consent/gdpr`;

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Removes the specified GDPR consent, or all consents.
     * Remove GDPR consent of current user
     */
    async deleteConsentGdprRaw(requestParameters: DeleteConsentGdprRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.deleteConsentGdprRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Removes the specified GDPR consent, or all consents.
     * Remove GDPR consent of current user
     */
    async deleteConsentGdpr(requestParameters: DeleteConsentGdprRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteConsentGdprRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for getConsentGdpr without sending the request
     */
    async getConsentGdprRequestOpts(requestParameters: GetConsentGdprRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['slashIDSdkVersion'] != null) {
            headerParameters['SlashID-SdkVersion'] = String(requestParameters['slashIDSdkVersion']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/consent/gdpr`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns the GDPR consent levels and timestamp for current person, if it exists. 
     * Get GDPR consent of current user
     */
    async getConsentGdprRaw(requestParameters: GetConsentGdprRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetConsentGdpr200Response>> {
        const requestOptions = await this.getConsentGdprRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetConsentGdpr200ResponseFromJSON(jsonValue));
    }

    /**
     * Returns the GDPR consent levels and timestamp for current person, if it exists. 
     * Get GDPR consent of current user
     */
    async getConsentGdpr(requestParameters: GetConsentGdprRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetConsentGdpr200Response> {
        const response = await this.getConsentGdprRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for postConsentGdpr without sending the request
     */
    async postConsentGdprRequestOpts(requestParameters: PostConsentGdprRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['gDPRConsentRequest'] == null) {
            throw new runtime.RequiredError(
                'gDPRConsentRequest',
                'Required parameter "gDPRConsentRequest" was null or undefined when calling postConsentGdpr().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['slashIDSdkVersion'] != null) {
            headerParameters['SlashID-SdkVersion'] = String(requestParameters['slashIDSdkVersion']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/consent/gdpr`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GDPRConsentRequestToJSON(requestParameters['gDPRConsentRequest']),
        };
    }

    /**
     * Stores the GDPR consent levels and timestamp. Returns the consent levels and the timestamp at which the consent information was received. This will overwrite existing GDPR consent levels for the specified person. The consent levels indicate the types of data classes the person has allowed during their use of your services, in accordance with GDPR. 
     * Store GDPR consent of current user
     */
    async postConsentGdprRaw(requestParameters: PostConsentGdprRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PutConsentGdpr200Response>> {
        const requestOptions = await this.postConsentGdprRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PutConsentGdpr200ResponseFromJSON(jsonValue));
    }

    /**
     * Stores the GDPR consent levels and timestamp. Returns the consent levels and the timestamp at which the consent information was received. This will overwrite existing GDPR consent levels for the specified person. The consent levels indicate the types of data classes the person has allowed during their use of your services, in accordance with GDPR. 
     * Store GDPR consent of current user
     */
    async postConsentGdpr(requestParameters: PostConsentGdprRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PutConsentGdpr200Response> {
        const response = await this.postConsentGdprRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for putConsentGdpr without sending the request
     */
    async putConsentGdprRequestOpts(requestParameters: PutConsentGdprRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['gDPRConsentRequest'] == null) {
            throw new runtime.RequiredError(
                'gDPRConsentRequest',
                'Required parameter "gDPRConsentRequest" was null or undefined when calling putConsentGdpr().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['slashIDSdkVersion'] != null) {
            headerParameters['SlashID-SdkVersion'] = String(requestParameters['slashIDSdkVersion']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/consent/gdpr`;

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: GDPRConsentRequestToJSON(requestParameters['gDPRConsentRequest']),
        };
    }

    /**
     * Stores the GDPR consent levels and timestamp. Returns the consent levels and the timestamp at which the consent information was received. This will overwrite existing GDPR consent levels for the specified person. The consent levels indicate the types of data classes the person has allowed during their use of your services, in accordance with GDPR. 
     * Set GDPR consent of current user
     */
    async putConsentGdprRaw(requestParameters: PutConsentGdprRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PutConsentGdpr200Response>> {
        const requestOptions = await this.putConsentGdprRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PutConsentGdpr200ResponseFromJSON(jsonValue));
    }

    /**
     * Stores the GDPR consent levels and timestamp. Returns the consent levels and the timestamp at which the consent information was received. This will overwrite existing GDPR consent levels for the specified person. The consent levels indicate the types of data classes the person has allowed during their use of your services, in accordance with GDPR. 
     * Set GDPR consent of current user
     */
    async putConsentGdpr(requestParameters: PutConsentGdprRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PutConsentGdpr200Response> {
        const response = await this.putConsentGdprRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
